export const promotedPrice = {
  ACCOMMODATION: 'PromotedPrice.Accommodation'
}
